import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static targets = ["select"]
  static values = {
    focused: { type: Boolean, default: false },
    remote: { type: Boolean, default: false },
    remoteUrl: { type: String, default: '/users/simple_search' },
    remoteField: { type: String, default: 'fi_name' }
  }

  connect() {
    if (this.selectTarget.tomselect) return

    const isMultiple = this.selectTarget.multiple
    const isRemote = this.remoteValue

    const plugins = {
      'clear_button': { title: 'Очистить' }
    }

    if (isMultiple) {
      plugins['remove_button'] = { title: 'Удалить' }
    }

    const ru = 'йцукенгшщзхъфывапролджэячсмитьбю.?'
    const en = 'qwertyuiop[]asdfghjkl;\'zxcvbnm,./&'

    const switchLayout = (text) => {
      return text.split('').map(char => {
        const isUpper = char === char.toUpperCase()
        const lowerChar = char.toLowerCase()

        let idx = en.indexOf(lowerChar)
        if (idx !== -1) {
          return isUpper ? ru[idx].toUpperCase() : ru[idx]
        }

        idx = ru.indexOf(lowerChar)
        if (idx !== -1) {
          return isUpper ? en[idx].toUpperCase() : en[idx]
        }

        return char
      }).join('')
    }

    const config = {
      valueField: 'value',
      labelField: 'text',
      searchField: ['text'],
      maxOptions: 200,
      plugins: plugins,
      closeAfterSelect: true,
      controlClass: 'ts-control rounded shadow-sm bg-white text-gray-900 px-3 py-2 min-h-[38px] flex flex-wrap gap-1 items-center cursor-pointer transition-all focus-within:border-orange-500 focus-within:ring-orange-500 focus-within:ring-2 sm:text-sm',
      dropdownClass: 'ts-dropdown absolute z-50 bg-white border border-gray-300 rounded shadow-lg mt-1 max-h-60 overflow-y-auto w-full left-0 right-0 sm:text-sm',
      optionClass: 'ts-option p-2 cursor-pointer hover:bg-orange-50 hover:text-orange-900 transition-colors',

      dataAttr: (html_node) => {
        return {
          value: html_node.value,
          text: html_node.text,
          avatar: html_node.dataset.avatar || "",
          initials: html_node.dataset.initials || ""
        };
      },

      onItemAdd: function() {
        this.setTextboxValue('');
        this.refreshOptions(false);
      },
      score: function(search) {
        let cleanSearch = search.trim();
        if (cleanSearch.length > 300) {
          cleanSearch = cleanSearch.substring(0, 300);
        }

        const score_original = this.getScoreFunction(cleanSearch)
        const altSearch = switchLayout(cleanSearch)
        const score_alt = this.getScoreFunction(altSearch)

        return function(item) {
          return Math.max(score_original(item), score_alt(item))
        }
      },
      render: {
        option: (data, escape) => this.renderUserRow(data, escape, false),
        item: (data, escape) => this.renderUserRow(data, escape, true),
        controlInput: () => '<input type="text" autocomplete="off" class="bg-transparent border-0 p-0 m-0 outline-none focus:ring-0 focus:border-0 sm:text-sm placeholder-gray-400 shrink min-w-[60px] flex-1">'
      }
    }

    if (isRemote) {
      config.load = (query, callback) => {
        let cleanQuery = query.trim();
        if (cleanQuery.length > 300) {
          cleanQuery = cleanQuery.substring(0, 300);
        }

        cleanQuery = cleanQuery.replace('-', ' ');

        const url = `${this.remoteUrlValue}?query=${encodeURIComponent(cleanQuery)}`;

        fetch(url)
          .then(response => {
            if (!response.ok) throw new Error();
            return response.json();
          })
          .then(data => callback(data.length > 0 ? data : undefined))
          .catch(() => {
            alert('Ошибка при попытке найти записи по вашему запросу');
            callback();
          });
      }
    }

    this.ts = new TomSelect(this.selectTarget, config)

    if (this.focusedValue) {
      this.ts.focus();
    }
  }

  disconnect() {
    if (this.ts) this.ts.destroy()
  }

  renderUserRow(data, escape, isItem) {
    const isMultiple = this.selectTarget.multiple

    if (isItem) {
      const itemWrapperClass = isMultiple
        ? "bg-orange-50 border border-orange-200 rounded px-2 py-0.5"
        : ""

      return `
        <div class="ts-user-item flex items-center ${itemWrapperClass}">
          <span class="text-gray-900">${escape(data.text)}</span>
        </div>
      `
    }

    const isStaticOption = ["none", "self"].includes(data.value)
    const hasAvatar = data.avatar && data.avatar.trim() !== ""
    const initials = data.initials || ""

    let avatarHtml = ""

    if (!isStaticOption) {
      avatarHtml = hasAvatar
        ? `<img src="${escape(data.avatar)}" alt="${escape(data.text)}" class="w-6 h-6 rounded-full object-cover shrink-0 aspect-square" />`
        : `<div class="w-6 h-6 rounded-full bg-gray-200 flex items-center justify-center shrink-0 aspect-square">
           <span class="text-[10px] font-medium text-gray-600">${escape(initials)}</span>
         </div>`
    }

    return `
      <div class="ts-user-item flex items-center gap-1.5">
        ${avatarHtml}
        <span class="text-gray-900 text-xs">${escape(data.text)}</span>
      </div>
    `
  }
}
